// extracted by mini-css-extract-plugin
module.exports = {"message":"DeleteArtistModalContent-message-2A0xw","pathContainer":"DeleteArtistModalContent-pathContainer-3GOar","path":"DeleteArtistModalContent-path-XUrC-"};